import { SET_SEARCH_TERM, SET_RESULTS, 
    UPDATE_SELECTED_DIDS, /*SET_SMS_MARKETING,*/
    UPDATE_BULK_SMS_PACKAGE, SELECT_SMS_TAB, 
    SET_LOADING_DID_RESULTS, SET_ERROR_DID_RESULTS,
    SET_BULK_SMS_PACKAGES } from '../actions/DIDsActions'

const initialState = {
    searchTerm: "",
    results: {
        isLoading: false,
        error: false,
        errorMessage: "",
        dids: [
            /*
            {
                id: <DID>,
                num: <DID>,
                price: <PRICE>,
                setup: <SETUP-PRICE>,
                api: <PROV>
            },
            */
            /*{
                id: "1",
                num: "1",
                price: 0.99,
                setup: 0.99,
                api: "NX",
                smsok: true,
            },
            {
                id: "2",
                num: "2",
                price: 0.99,
                setup: 0.99,
                api: "NX",
                smsok: false,
            },
            {
                id: "3",
                num: "3",
                price: 0.99,
                setup: 0.99,
                api: "NX",
                smsok: true,
            },
            {
                id: "4",
                num: "4",
                price: 0.99,
                setup: 0.99,
                api: "NX",
                smsok: true,
            },*/
        ],
    },
    DIDsAdded: [
        /*{
            DID: "17022763513",
            411: false,
            E911: false,
            CName: false,
            price: 0.99,
            isUnlimited: false,
            api: {the same object got from the ajax}
        },
        */
    ],
    //isSmsMarketing: undefined,
    bulkPackagesSelected: {
        "S": 0,
        "M": 0,
        "L": 0,
        "XL": 0,
    },
    selectedSMSTab: 0,
}

const DIDsReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.newValue,
            }
        case SET_RESULTS:
            return {
                ...state,
                results: {
                    ...state.results,
                    isLoading: false,
                    error: false,
                    errorMessage: "",
                    dids: action.newResults,
                }
            }
        case SET_LOADING_DID_RESULTS:
            return {
                ...state,
                results: {
                    ...state.results,
                    isLoading: action.newValue,
                    error: false,
                    errorMessage: "",
                    dids: [],
                }
            }
        case SET_ERROR_DID_RESULTS:
            return {
                ...state,
                results: {
                    ...state.results,
                    isLoading: false,
                    error: true,
                    errorMessage: action.errorMessage,
                    dids: [],
                }
            }
        case UPDATE_SELECTED_DIDS:
            return {
                ...state,
                DIDsAdded: action.newResults,
            }
        /*case SET_SMS_MARKETING:
            return {
                ...state,
                isSmsMarketing: action.newValue,
            }*/
        case UPDATE_BULK_SMS_PACKAGE:
            return {
                ...state,
                bulkPackagesSelected: {
                    ...state.bulkPackagesSelected,
                    [action.packageId]: action.newAmount,
                }
            }
        case SET_BULK_SMS_PACKAGES:
            return {
                ...state,
                bulkPackagesSelected: {
                    ...state.bulkPackagesSelected,
                    ...action.newValue,
                }
            }
        case SELECT_SMS_TAB:
            return {
                ...state,
                selectedSMSTab: action.newValue,
            }
        default:
            return state;
    }
}

export default DIDsReducer;